import React from "react";
import { FormButtonContainer, NarrowFormCardContainer, NarrowFormPage } from "../../styles/globalStyles";
import Snackbar from "../../shared/Snackbar";
import {
    FormCardWrapper,
    FormHeaderWrapper,
    FormContentWrapper
  } from "./BaseFormPageStyles";

export default ({
    logger,
    header,
    form,
    buttons,
    feedbackState
}) => {

    return (
        <NarrowFormPage>
        {logger}
  
        <NarrowFormCardContainer>
          <FormCardWrapper>
            <FormHeaderWrapper>
              <h2>{header}</h2>
            </FormHeaderWrapper>
  
            <FormContentWrapper>
              {form}
            </FormContentWrapper>
          </FormCardWrapper>
  
          <FormButtonContainer>
            {buttons}
          </FormButtonContainer>
        </NarrowFormCardContainer>
  
        {feedbackState && <Snackbar feedback={feedbackState} />}
      </NarrowFormPage>
    );

}